<script>
export default {
  name: "stillhavequestions"
};
</script>

<template>
  <el-row style="padding: 20px 0 20px 0; background-color: #ffffff">
    <el-row>
      <el-col
        :span="24"
        style="display: flex; justify-content: left; align-items: center"
      >
        <span class="search-text" style="z-index: 11">Still have</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col
        :span="24"
        style="display: flex; justify-content: left; align-items: center"
      >
        <span class="search-text" style="z-index: 11">questions?</span>
      </el-col>
    </el-row>

    <el-row>
      <el-col
        :span="24"
        style="display: flex; justify-content: center; padding: 0 16px 16px 16px"
      >
        <el-button class="help-btn" type="primary">Help Center</el-button>
      </el-col>
    </el-row>
  </el-row>
</template>

<style scoped>
.search-text {
  color: #003333;
  text-align: left;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "DINosaur-a", sans-serif;
  font-size: 35px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding-left: 20px;
}

.help-btn {
  color: #ffffff;
  text-align: center;
  border: 3px solid #003333;
  background-color: #003333;
  width: 100%;
  margin-top: 24px;
  font: 600 20px DINosaur-a, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/package/stillHaveQuestions.vue